import React, { Component } from 'react';
import { Text, StyleSheet, Animated } from 'react-native';
import { observer } from 'mobx-react/native';

interface Props {
    size?: number;
    animatable?: boolean;
    code: string;
    style?: object[] | object;
}

@observer
class Icon extends Component<Props> {
    public render() {
        const { size = 14, animatable } = this.props;
        let { style = [], code } = this.props;
        if (!Array.isArray(style)) {
            style = [style];
        }
        if (/^&#x([a-z0-9]{4});$/.test(code)) {
            /* eslint-disable */
            // code = code.replace(/&#x(.*);/, '\\u$1')
        }
        return animatable ? (
            <Animated.Text style={[styles.code, { fontSize: size }, ...style]}>
                {code}
            </Animated.Text>
        ) : (
            <Text style={[styles.code, { fontSize: size }, ...style]}>{code}</Text>
        );
    }
}
const styles = StyleSheet.create({
    code: {
        fontFamily: 'cmn_component_order-0_0_9'
    }
});

export default Icon;
